import { supabase } from '../supabaseClient';

export async function invokeFunction(functionName, body) {
  const { data, error } = await supabase.functions.invoke(functionName, { body });

  if (error) {
    throw error;
  }

  if (data?.error) {
    throw new Error(data.error);
  }

  return data?.data ?? data;
}
